import React from 'react';
import { Container } from '@/components/layout/Container';
import { Reveal } from '@/components/layout/Reveal';
import { useI18n } from '@/lib/i18n';

/** Dark editorial proof band: the numbers, stated plainly and confidently. */
export const StatBand = () => {
  const { t } = useI18n();

  return (
    <section
      data-testid="home-stats-band"
      className="relative overflow-hidden rmh-grain"
      style={{ backgroundColor: 'var(--rmh-ink)' }}
    >
      <Container wide className="relative z-10 py-14 lg:py-20">
        <Reveal>
          <div className="flex items-center gap-3">
            <span
              className="block h-px w-8"
              style={{ backgroundColor: 'var(--rmh-accent)' }}
              aria-hidden="true"
            />
            <span className="rmh-eyebrow" style={{ color: 'rgba(250,247,242,0.62)' }}>
              {t.statsBand.eyebrow}
            </span>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-10 sm:grid-cols-3 sm:gap-8">
          {t.stats.map((stat, i) => (
            <Reveal key={stat.testId} delay={i * 0.08}>
              <div data-testid={stat.testId} className="relative sm:pl-8 sm:first:pl-0">
                <span
                  aria-hidden="true"
                  className="absolute left-0 top-1 hidden h-[calc(100%-0.5rem)] w-px sm:block"
                  style={{
                    backgroundColor: 'rgba(250,247,242,0.14)',
                    display: i === 0 ? 'none' : undefined,
                  }}
                />
                <p
                  className="rmh-num text-[2.4rem] leading-none sm:text-[2.7rem] lg:text-[3.2rem]"
                  style={{ color: 'var(--rmh-canvas)', letterSpacing: '-0.03em' }}
                >
                  {stat.value}
                </p>
                <p
                  className="mt-4 font-serif text-[1.02rem] leading-snug"
                  style={{ color: 'var(--rmh-canvas)' }}
                >
                  {stat.label}
                </p>
                <p
                  className="mt-2 text-[0.8rem] leading-relaxed"
                  style={{ color: 'rgba(250,247,242,0.58)' }}
                >
                  {stat.note}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>

      {/* Editorial marquee */}
      <div
        className="relative z-10 overflow-hidden border-t py-4"
        style={{ borderColor: 'rgba(250,247,242,0.12)' }}
        aria-hidden="true"
      >
        <div className="rmh-marquee-track flex w-max items-center gap-10 whitespace-nowrap">
          {[...t.marquee, ...t.marquee, ...t.marquee, ...t.marquee].map((word, i) => (
            <span key={`${word}-${i}`} className="flex items-center gap-10">
              <span
                className="text-[0.7rem] font-medium uppercase tracking-[0.28em]"
                style={{ color: 'rgba(250,247,242,0.5)' }}
              >
                {word}
              </span>
              <span
                className="block h-1 w-1 rounded-full"
                style={{ backgroundColor: 'var(--rmh-accent)' }}
              />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatBand;
